import React from "react";
import "./history.css";

import image1 from "../../assets/img/history/h_image1.png";
import image2 from "../../assets/img/history/h_image2.png";
import image3 from "../../assets/img/history/h_image3.png";
import polygon from "../../assets/img/history/h_polygon.png";
import polygonDown from "../../assets/img/history/h_polygon_dow.png";
import star from "../../assets/img/history/h_star.png";
import { useResolution } from "../../utils/resolutionControll";

const historyTitle = "A Ripafactory nasceu do coração da Ripaxote ";

const historyText = `A Ripafactory foi criada com um propósito claro: unir música, impacto social e sustentabilidade. Somos uma empresa do setor 2.5, comprometida não apenas com a fabricação de instrumentos musicais percussivos, mas também com a transformação de vidas. 

Nosso diferencial reside na maneira como realizamos essa missão: empregando jovens da comunidade e oferecendo um futuro repleto de possibilidades. 

Acreditamos no poder transformador da música. Nossa missão é fazer com que cada instrumento se torne mais do que um objeto: uma ponte para o futuro, um portal de oportunidades e a peça-chave na vida de jovens que sonham, criam e se descobrem através do som.`;

const History: React.FC = ({}) => {
  const width = useResolution();
  const isMobile = width < 750;
  return (
    <div className="history">
      <div className="history-content">
        <img src={polygon} alt="imagem de fundo de um poligano" />
      </div>
      <div className="history-midle-text-conatiner">
        <div className="history-midle-text-content">
          <img src={star} alt="imagem de estrela" />
          <p className="big-text">MÚSICA</p>
        </div>

        <div className="history-midle-text-content">
          <img src={star} alt="imagem de estrela" />
          <p className="big-text">SUSTENTABILIDADE</p>
        </div>

        <div className="history-midle-text-content">
          <img src={star} alt="imagem de estrela" />
          <p className="big-text">IMPACTO SOCIAL</p>
        </div>
      </div>

      <div className="history-midle-wrap-text-conatiner ">
        <div className="history-midle-wrap-text-content">
          <h1>{historyTitle}</h1>

          <p>
            {historyText.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>

        {isMobile ? (
            <div style={{maxHeight: "250px"}}>
                <img className="polygonDown" src={polygonDown} alt="Figura de um Poligano" /> 
            </div>
        ) 
        
        
        : (<div style={{width: "1px", height:"1px"}}></div>)}

        <div className="history-midle-wrap-img-content">
          <img src={image3} alt="Homem sentado tocando Ripaton" />
        </div>
      </div>
    </div>
  );
};

export default History;
